import { useTranslation } from "react-i18next";
import {
    ResponsiveContainer,
    LineChart,
    XAxis,
    YAxis,
    Tooltip,
    Line,
    CartesianGrid,
    ReferenceLine,
} from "recharts";

export const ECGGraph = ({ ecg }) => {

    const [t] = useTranslation(["global", "health"]);

    const normalizeECGData = (data) => {
        if (!data.length) return [];

        const startTime = data[0].timestamp;
        return data.map(p => ({
            ...p,
            timeOffsetMs: p.timestamp - startTime,
            mV: p.mV // per chiarezza
        }));
    };


    return (
        <div>
            <div className="d-flex justify-content-between mb-3">
                <div>
                    <h6>
                        <i className="fa-solid fa-clock"></i> {new Date(ecg[0].timestamp).toLocaleTimeString()} - {new Date(ecg.at(-1).timestamp).toLocaleTimeString()}
                    </h6>


                </div>
                <span className="small text-muted">500 HZ</span>
                <span className="small text-muted">{ecg.length} {t("health:unit.points")}</span>
            </div>

            {ecg?.length > 0 ? (
              <div className="d-flex overflow-x--scroll" style={{ overflowX: "scroll" }}>
                    
                  <div style={{ width: "100%" }}>
                            <LineChart className={"bg-white"} data={normalizeECGData(ecg)} width={ecg?.length*3} height={350} margin={{ top: 10, left: 0, right: 0, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                                <Tooltip />
                                <XAxis
                                    dataKey="timeOffsetMs"
                                    tickCount={10}
                                    unit="ms"
                                    domain={["auto", "auto"]}
                                    dy={10}
                                />
                                <YAxis
                                    dataKey="mV"
                                    domain={[-1, 1]}
                                    ticks={[-1, -0.5, 0, 0.5, 1]}
                                    unit="mV"
                                    //  width={0}
                                />

                                <ReferenceLine y={0} stroke="#888" strokeDasharray="2 2" />
                                <Line
                                    type="linear"
                                    dataKey="mV"
                                    stroke="red"
                                    dot={false}
                                    isAnimationActive={false}
                                />
                            </LineChart>
                    </div>
                </div>
            ) : (
                <h3 className="text-muted">{t("health:helper.no_data")}</h3>
            )}
        </div>
    );
};
